import { style } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const carouselScrollContainer = style({
  display: "flex",
  gap: vars.space.xs,
  padding: `0 ${vars.space.xs}`,
});

export const headingContainer = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingBottom: vars.space.m,
});

export const buttonsContainer = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
});

export const carouselViewport = style({
  overflow: "hidden",
});
